<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('productRecipe.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('productRecipe.pageTitle'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="ts-flex ts-justify-end ts-items-center">
          <div class="ts-flex ts-space-x-3">
            <select 
                v-tooltip="$t('productRecipe.productType')"
                v-model="productTypeId"
                class="form-control"
            >
              <option :value="1">Assembly</option>
              <option :value="2">Non-Assembly</option>
            </select>
            <ts-input
              v-tooltip="$t('productRecipe.search')"
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <Table
          :data="resources" 
          :columns="columns" 
          size="small"
          highlight-row
          stripe
          max-height="700"
          :loading="loading"
        >
            <template slot-scope="{ row }" slot="groupNameEn">
              {{ row.group ? row.group.pro_group_name_en : null }}
            </template>
            <template slot-scope="{ row }" slot="categoryNameEn">
              {{ row.product_category.category_name_en }}
            </template>
            <template slot-scope="{ row }" slot="addOnCount">
              <span
                class="badge badge-success"
                v-if="row.product_add_on_count"
                >Yes</span
              >
              <span class="badge badge-danger" v-else>No</span>
            </template>
            <template slot-scope="{ row }" slot="action">
              <a
                href="#"
                v-tooltip="$t('add_new')"
                @click.prevent="chosen(row)"
              >
                <i class="fa fa-plus"></i>
              </a>
            </template>
        </Table>
      </div>
      <div class="d-flex justify-content-between align-items-center p-15">
        <ts-total-list v-model="pagination" />
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'addOnIndex',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapState('product/addOn', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.addOn.search
      },
      set(newValue) {
        this.$store.commit('product/addOn/SET_SEARCH', newValue)
        this.$store.commit('product/addOn/RESET_CURRENT_PAGE')
      },
    },
    productTypeId: {
      get() {
        return this.$store.state.product.addOn.product_type_id
      },
      set(newValue) {
        this.$store.commit('product/addOn/SET_PRODUCT_TYPE_ID', newValue)
      },
    },
    columns() {
      return [
        { 
          title: this.$t('productRecipe.barcode'),
          key: 'barcode', 
          style: 'width: 11%' 
        },
        { 
          title: this.$t('productRecipe.group'),
          slot: 'groupNameEn' 
        },
        { 
          title: this.$t('productRecipe.nameKh'),
          key: 'product_name_kh' 
        },
        { 
          title: this.$t('productRecipe.nameEn'),
          key: 'product_name_en' 
        },
        { 
          title: this.$t('productRecipe.category'),
          slot: 'categoryNameEn' 
        },
        { 
          title: this.$t('productRecipe.addOn'),
          align: 'center',
          slot: 'addOnCount' 
        },
        {
					title: this.$t('actions'),
					key: 'action',
					slot: 'action',
					fixed: 'right',
					align: 'center',
					width: 94
				}
      ]
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/addOn/fetch', { ...attributes })
        .then((response) => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    chosen(record) {
      this.$router.push({
          name: 'product-add-on-create',
          params: {
              id: record.product_id
          },
          query: {
              product_type_id: record.product_type_id
          }
      })
    },
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData()
    }, 500),
    productTypeId: debounce(function (search) {
      this.fetchData()
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/addOn/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData()
    })
  },
}
</script>